import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ACHWithdrawResponse | undefined,
  (requestParams?: vp.ACHWithdrawRequest) => void,
  () => void,
  (requestParams: vp.ACHWithdrawRequest) => Promise<vp.ACHWithdrawResponse>,
];

function usePostACHWithdraw({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.ACHWithdrawRequest>();
  const [response, setResponse] = useState<vp.ACHWithdrawResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.ACHWithdrawRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postACHWithdraw(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: vp.ACHWithdrawRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
    (requestParams: vp.ACHWithdrawRequest) => api.postACHWithdraw(requestParams, source),
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostACHWithdraw);
